import type { FormResponse } from "@prequel/import-react";

import { importClient } from "./sdk/client";

// Form endpoints are internal to the app: they are not part of the published import API
// and have no SDK client. These stay plain fetchers because useDynamicForm owns the
// request lifecycle (loading, refetch-on-change, and the request-id race guard).

// Which of a resource's two contracts the form describes. An edit form returns the same
// fields as a create one, but marks everything the PATCH endpoint does not accept as
// read-only; the API's update options struct is what decides that, not the caller.
export type FormMode = "create" | "edit";

const withMode = (path: string, mode: FormMode) => (mode === "edit" ? `${path}?mode=edit` : path);

export const fetchDatalakeForm = (datalake: unknown, mode: FormMode = "create"): Promise<FormResponse> =>
  importClient.post<FormResponse>(withMode("/import/forms/datalakes", mode), { datalake });

export const fetchDestinationForm = (destination: unknown, mode: FormMode = "create"): Promise<FormResponse> =>
  importClient.post<FormResponse>(withMode("/import/forms/destinations", mode), { destination });
